import React, { useState } from 'react'
import { Collapse as CollapseLib } from 'react-collapse'
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md'
import PropTypes from 'prop-types'
import Flex from '../Flex/Flex'
import Text from '../Text/Text'
import styles from './collapse.module.scss'

const Collapse = ({ children, title, opened }) => {
  const [open, setOpen] = useState(opened)

  return (
    <div className={styles.container}>
      {title && (
        <Flex
          flex="1"
          alignItems="center"
          justifyContent="space-between"
          onClick={() => setOpen(!open)}
        >
          <Text size="sm" color="gray" variation="dark" bold>
            {title}
          </Text>
          {!open ? <MdArrowDropDown size={20} /> : <MdArrowDropUp size={20} />}
        </Flex>
      )}
      <CollapseLib isOpened={open} theme={{ content: styles.content }}>
        {children}
      </CollapseLib>
    </div>
  )
}

Collapse.defaultProps = {
  opened: false,
  title: false
}

Collapse.propTypes = {
  opened: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
    PropTypes.node
  ]).isRequired
}

export default Collapse
